import {
  CLAIM_VERDICT_LABEL,
  CLAIM_VERDICT_TONE,
  type ClaimResult,
  type ClaimVerdict,
} from '@cyberscore/contracts';
import { FileCheck2, FileQuestion, FileWarning, FileX2 } from 'lucide-react';

const PILL: Record<(typeof CLAIM_VERDICT_TONE)[ClaimVerdict], string> = { good: 'ok', warn: 'warn', bad: 'bad', neutral: 'neutral' }; // prettier-ignore
const ICON: Record<ClaimVerdict, typeof FileCheck2> = {
  supported: FileCheck2,
  not_supported: FileQuestion,
  contradicted: FileX2,
  cant_tell: FileWarning,
};

export const verdictPill = (v: ClaimVerdict) => PILL[CLAIM_VERDICT_TONE[v]];

/**
 * What the business's documents say about an answer (task 62): each check with its verdict, why, and the
 * words and page it rests on.
 */
export function ClaimList({ claims, compact = false }: { claims: ClaimResult[]; compact?: boolean }) {
  if (!claims.length) return null;
  return (
    <ul className="claim-list" aria-label="Document checks">
      {claims.map((c) => {
        const Icon = ICON[c.verdict];
        return (
          <li key={c.id} className={`claim ${verdictPill(c.verdict)}`}>
            <div className="row gap wrap">
              <Icon size={14} aria-hidden />
              <span className={`pill ${verdictPill(c.verdict)}`}>{CLAIM_VERDICT_LABEL[c.verdict]}</span>
              <span className="small">{c.description}</span>
            </div>
            {!compact && <div className="muted small">{c.reason}</div>}
            {c.document?.quote && (
              <blockquote className="claim-quote small">
                “{c.document.quote}”
                <span className="muted">
                  {' '}
                  · {c.document.file_name}
                  {c.document.page ? `, page ${c.document.page}` : ''}
                </span>
              </blockquote>
            )}
          </li>
        );
      })}
    </ul>
  );
}
